import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction, Draft } from "@reduxjs/toolkit";

export interface HelpPanelState {
  hide: boolean;
  open: boolean;
  header?: JSX.Element;
  content?: JSX.Element;
  footer?: JSX.Element;
}

const initialState = {
  hide: true,
  open: false,
} as HelpPanelState;

const helpPanelSlice = createSlice({
  name: "helpPanel",
  initialState,
  reducers: {
    openHelpPanel: (
      state,
      action: PayloadAction<{
        header?: Draft<JSX.Element>;
        content?: Draft<JSX.Element>;
        footer?: Draft<JSX.Element>;
      }>
    ) => {
      const { header, content, footer } = action.payload;
      state.hide = false;
      state.open = true;
      state.header = header;
      state.content = content;
      state.footer = footer;
    },
    closeHelpPanel: (state) => {
      state.hide = true;
      state.open = false;
      state.header = undefined;
      state.content = undefined;
      state.footer = undefined;
    },
  },
});

export const { openHelpPanel, closeHelpPanel } = helpPanelSlice.actions;

export default helpPanelSlice.reducer;
